import { Button, ButtonProps } from "@chakra-ui/react";
import useDownloadPdf from "@modules/ProductDetail/hooks/useDownloadPdf";
import { IResourceCategory } from "@modules/Resource/models/resourceCategory";
import React, { memo } from "react";

interface IProps extends ButtonProps {
  item: IResourceCategory | null | undefined;
  label: string;
}

const DownloadButton: React.FC<IProps> = ({
  item,
  label = "Download",
  ...rest
}) => {
  if (!item) return null;

  const { name, download_file } = item?.attributes;
  const onDownloadPdf = useDownloadPdf();

  return (
    <Button
      textStyle={"hind_m"}
      disabled={!download_file}
      onClick={() => onDownloadPdf(download_file!.data!.attributes.url, name)}
      {...rest}
    >
      {label}
    </Button>
  );
};

export default memo(DownloadButton);
